import { useEffect, useState } from "react";
import Loading from "../../../components/Loading";
import { colors } from "../../../assets/colors";
import { createUpdateTestCase } from "../../../api/projects";
import { ProjectsTypes } from "../../../interfaces/ProjectsTypes";
import { display } from "html2canvas/dist/types/css/property-descriptors/display";
import Row from "../../../components/layout/Row";
import ButtonLoading from "../../../components/ButtonLoading";

interface Props {
  currentProject: ProjectsTypes;
}

export default function ScenarioGeneratorTab({ currentProject }: Props) {
  const [imagem, setImagem] = useState<File | null>(null);
  const [imagemPreview, setImagemPreview] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [cenarios, setCenarios] = useState<string>("");
  const [erro, setErro] = useState<string>("");

  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setImagem(file);
      setImagemPreview(URL.createObjectURL(file));
      setErro("");
    }
  };

  const gerarCenarios = async () => {
    if (!imagem) return;
    setLoading(true);
    setErro("");
    setCenarios("");

    const reader = new FileReader();
    reader.onloadend = async () => {
      const base64 = (reader.result as string).split(",")[1];

      try {
        const res = await fetch("https://ia-qazando-7f8a9310f440.herokuapp.com/gerar-cenarios", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ imagemBase64: base64 }),
        });

        const data = await res.json();

        if (!res.ok) {
          setErro(data?.error || "Erro ao gerar os cenários.");
        } else {
          setCenarios(data.resultado);
        }
      } catch (e) {
        setErro("Erro de rede ou servidor.");
      } finally {
        setLoading(false);
      }
    };

    reader.readAsDataURL(imagem);
  };

  const [testCases, setTestCases] = useState<any[]>([]);

  const salvarTestes = async () => {
    try {
      await createUpdateTestCase(
        "",
        currentProject.project_id,
        1738328209647,
        testCases,
        new Date().getTime().toString()
      );

      alert("Testes salvos na suíte com sucesso!");
    } catch (e) {
      console.error(e);
      alert("Erro ao salvar os testes na suíte.");
    }
  };

  useEffect(() => {
    if (cenarios) {
      const linhas = cenarios.split("Scenario:");
      const mapeado = linhas
        .filter((l) => l.trim() !== "")
        .map((line) => ({
          title: "Scenario:" + line.trim().split("\n")[0],
          id: Date.now() + Math.floor(Math.random() * 10000),
          project_id: currentProject.project_id,
          suite: 1738328209647,
        }));
      setTestCases(mapeado);
    }
  }, [cenarios]);

  return (
    <div style={styles.content}>
      <h2>🧠 Gerador de Cenários</h2>

      <Row style={{ gap: 12 }}>
        <input type="file" accept="image/*" onChange={handleUpload} />

        <ButtonLoading
          label={loading ? "Gerando Cenários..." : "Gerar Cenários"}
          onClick={gerarCenarios}
          disabled={loading || !imagem}
          style={styles.button}
        />
      </Row>

      {imagemPreview && (
        <img src={imagemPreview} alt="Preview" style={styles.preview} />
      )}

      {loading && <Loading />}

      {cenarios && <pre style={styles.output}>{cenarios}</pre>}

      {erro && <p style={styles.erro}>{erro}</p>}
    </div>
  );
}

const styles: any = {
  content: {
    backgroundColor: colors.white,
    marginTop: 50,
    marginLeft: 12,
    marginRight: 12,
    padding: 24,
    borderRadius: 8,
    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
    display: "flex",
    flexDirection: "column",
  },
  preview: {
    marginTop: 16,
    maxWidth: "50%",
  },
  button: {
    padding: "10px 20px",
    backgroundColor: colors.primary,
    color: "#fff",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
    marginTop: 10,
  },
  output: {
    marginTop: 24,
    backgroundColor: "#f6f6f6",
    padding: 16,
    borderRadius: 8,
    whiteSpace: "pre-wrap",
  },
  erro: {
    color: "red",
    marginTop: 12,
  },
};
